import makeStyles from '@mui/styles/makeStyles';
import {ChevronRight} from "lucide-react";
import React from "react";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {color, font, type} from "common/tokens";

const useStyles = makeStyles({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
  },
  eyebrow: {
    ...type.eyebrow,
    fontWeight: font.BOLD,
    letterSpacing: '1.43px',
    color: color.ACCENT_TEXT,
    margin: 0,
  },
  link: {
    ...type.meta,
    fontWeight: font.REGULAR,
    color: color.ACCENT_TEXT,
    textDecoration: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 2,
    whiteSpace: 'nowrap',
  },
});

const SectionLinkHeader = ({label, to}) => {
  const classes = useStyles();
  const {t} = useTranslation();

  return (
    <div className={classes.header}>
      <p className={classes.eyebrow}>{label}</p>
      {to && (
        <Link to={to} className={classes.link}>
          {t('viewAll')}
          <ChevronRight size={16} strokeWidth={2}/>
        </Link>
      )}
    </div>
  );
};

export default SectionLinkHeader;
